import type { LongCopy } from '../copy'

export const zh: LongCopy = {
  home: { title: 'ABV Develop 星球', lead: '这里是我们的团队与能力所在。环绕它运行的是各部门的卫星，更远处是我们为客户打造的项目星球。请选择目的地。', cta: '发送飞行任务' },
  team: {
    analytics: {
      name: '系统分析',
      tagline: '把业务翻译成系统的语言',
      about: '每个项目都从这里开始。分析师深入了解客户业务的真实运作方式，并将其转化为需求、流程图和 API 契约，让团队无需猜测即可开发。',
      facts: ['先理解流程，再编写代码', '需求文档、流程图与界面原型', '开发开始前先确定 API 契约'],
      soon: '分析团队的动态与发现即将上线',
    },
    ai: {
      name: 'AI 工程',
      tagline: '让智能融入真实的业务流程',
      about: '团队设计 AI 智能体、企业数据检索、文档识别，以及基于 MCP 标准的助手接入，让 AI 服务于真实流程，而不只是演示。',
      facts: ['AI 智能体与 MCP 服务器', '基于企业数据的检索与 RAG', '文档、扫描件与规格书识别'],
      soon: 'AI 团队的实验与动态即将上线',
    },
    development: {
      name: '开发',
      tagline: '打造可以稳定运行多年的系统',
      about: '后端与前端工程师依据约定的契约进行开发：代码评审、版本控制，以及能够承载增长负载和新功能的架构。',
      facts: ['后端与前端同属一个团队', '强制代码评审', '面向高负载的架构'],
      soon: '开发团队的动态与技术亮点即将上线',
    },
    testing: {
      name: '测试',
      tagline: '在客户发现之前找到问题',
      about: 'QA 工程师负责功能、集成与回归测试，自动化关键场景，并在每次上线前进行压力测试。',
      facts: ['功能、集成与回归测试', '关键流程自动化测试', '上线前压力测试'],
      soon: '测试团队的动态与挑战即将上线',
    },
    devops: {
      name: 'DevOps',
      tagline: '快速而稳定地交付',
      about: '自动化构建与部署到测试和生产环境，监控、环境安全与弹性扩展，让新版本频繁发布且没有意外。',
      facts: ['覆盖所有环境的 CI/CD', '监控与错误追踪', '集群与负载均衡'],
      soon: 'DevOps 团队的动态与技巧即将上线',
    },
  },
  projects: { platform: '分销数字平台', grid: '数字电网', panel: '10 分钟完成变电站' },
  careers: { name: '开放太空', lead: '这颗星球属于所有想和我们一起打造系统的人。每个职位都是一项独立的任务。', mission: '接受任务 →' },
  mission: {
    title: '任务“从想法到发布”',
    intro: '走一遍我们每个项目都会经历的路径：分析 → AI → 开发 → 测试 → 发布。最后您将获得一张可下载的祝福明信片。',
    progress: '任务阶段',
    locked: '完成“{name}”后解锁本阶段',
    goTo: '飞往该处',
    done: '阶段完成！',
    continueTo: '下一阶段：{name}',
    analytics: {
      task: '分析任务：选择 3 张卡片——这张明信片应该传达什么？',
      cards: [
        { id: 'calm', label: '平静' }, { id: 'energy', label: '活力' }, { id: 'luck', label: '好运' },
        { id: 'team', label: '献给团队' }, { id: 'bold', label: '大胆创意' }, { id: 'joy', label: '快乐' },
      ],
      pick: '已选：{n}/{total}',
      confirm: '确认需求',
    },
    ai: {
      task: 'AI 根据您的需求写下了几条祝福。请选出最好的一条。',
      generating: '模型思考中…',
      choose: '选择',
      quote: '“{text}”',
      wishes: {
        calm: ['愿您今天从容平静，每项任务都迎刃而解。'],
        energy: ['元气满满一整天，晚上还有余力！'],
        luck: ['愿今天的一切都一次成功。'],
        team: ['祝您和您的团队度过美好的一天！'],
        bold: ['愿今天的大胆想法都变成计划。'],
        joy: ['从今天开始，多一些微笑的理由！'],
      },
      fallback: ['祝您今天愉快，事事顺利！'],
    },
    development: {
      task: '用现成的组件拼出明信片。',
      backgrounds: ['深空', '极光', '轨道日落'],
      planets: ['ABV 星球', '光环巨行星', '蓝色卫星'],
      bg: '背景',
      planet: '星球',
      build: '开始构建',
    },
    testing: {
      task: '在构建中找出 3 个 bug——直接点击明信片上的问题。',
      found: '已找到：{n}/{total}',
      bugs: ['文字里的错别字', '位置错乱的星球', '多余的红色星星'],
      allFound: '所有 bug 已修复——版本可以发布了',
    },
    devops: {
      task: '全部测试通过。准备发布！',
      countdown: '倒计时',
      launch: '发布版本',
      released: '发布成功！',
    },
    postcard: {
      title: '您的明信片已完成',
      nameLabel: '送给谁',
      namePlaceholder: '姓名',
      from: '来自 ABV Develop 星系的祝福',
      download: '下载明信片',
      share: '复制网站链接',
      copied: '链接已复制',
      again: '再玩一次',
      greeting: '祝你今天愉快',
    },
  },
  brief: {
    title: '飞行任务',
    intro: '用四步描述您的需求——任务将飞向我们的团队，我们会尽快回复您。',
    steps: ['目的地', '载荷', '时间', '机组'],
    destination: '您需要什么样的系统？',
    destinations: [
      { id: 'erp', label: 'ERP / CRM', hint: '流程、财务、单据' },
      { id: 'catalog', label: '商品目录与搜索', hint: 'B2B 门户、海量商品' },
      { id: 'ai', label: 'AI 智能体', hint: '自动化、MCP、识别' },
      { id: 'engineering', label: '工程系统', hint: '能源、配置器、GIS' },
      { id: 'other', label: '其他', hint: '我们一起梳理' },
    ],
    cargo: '项目中哪些最重要？可多选',
    cargoItems: ['流程自动化', '与其他系统集成', '高负载', 'AI 与数据', '升级现有系统', '从零开始'],
    cargoNote: '简单描述一下需求（选填）',
    timeline: '希望什么时候开始？',
    timelines: ['越快越好', '1–3 个月内', '大约半年后', '还在了解中'],
    crew: '我们该联系谁？',
    name: '姓名',
    namePlaceholder: '例如：李娜',
    email: '工作邮箱',
    emailPlaceholder: 'name@company.com',
    message: '备注',
    requiredNote: '* 为必填项',
    nameError: '请告诉我们如何称呼您',
    emailError: '请检查邮箱地址，例如 name@company.com',
    pickDestination: '请选择一项后继续',
    pickTimeline: '请选择启动时间后继续',
    next: '下一步',
    back: '返回',
    launch: '提交需求',
    sending: '发送中…',
    sent: '您的需求已进入轨道！我们会尽快通过邮件回复您。',
    previewNote: '预览模式：邮件未实际发送',
    error: '发送失败。请重试，或发送邮件至 sales@abvdevelop.com。',
    rateLimited: '提交过于频繁。请 15 分钟后再试，或发送邮件至 sales@abvdevelop.com。',
    summary: '来自网站的飞行任务',
  },
  guide: {
    title: '想去哪里？',
    lead: '点击任意星球，或选择一条路线：',
    tour: '星系导览',
    tourText: '火箭带您依次游览 {total} 个站点，您只需点击“下一站”',
    recommended: '推荐',
    resume: '继续导览',
    resumeText: '您上次停在第 {n} 站（共 {total} 站）',
    missionText: '在团队卫星上完成 5 个小任务，最后领取一张明信片',
    missionProgress: '已完成 {n}/{total}',
    projects: '项目',
    projectsText: '我们打造的三个系统',
    request: '提交需求',
    requestText: '分 4 步描述您的需求，我们会通过邮件回复',
    meditate: '冥想——在太空中放松片刻',
    allPlanets: '全部星球',
    coachKicker: '使用方法',
    coachText: '点击任意星球，火箭就会带您飞过去',
    coachNote: '不知道从哪里开始？导览会带您走遍整个星系的 {total} 个站点，您只需点击“下一站”。',
    coachTour: '开始导览',
    coachSelf: '我自己看看',
    help: '帮助：使用方法',
    stop: '第 {n} 站，共 {total} 站',
    next: '下一站',
    back: '上一站',
    end: '结束导览',
    finish: '到达终点——您已游遍整个星系！',
    upNext: '下一站：{name}',
    fly: '出发',
    visited: '已到访',
    missionCount: '任务：{n}/{total}',
    stageDone: '已完成',
    stagePending: '未完成',
    nextTo: '下一站：{name}',
    nextPlanet: '下一颗星球：{name}',
    flyTo: '飞往{name}',
    note: '{text}（{note}）',
    stageLabel: '{name}：{status}',
  },
}
